<template>
  <div class="min-h-screen bg-gray-100">
    <!-- Navigation header -->
    <nav v-if="authStore.user" class="bg-white shadow">
      <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div class="flex h-16 justify-between">
          <div class="flex">
            <div class="flex flex-shrink-0 items-center">
              <router-link to="/" class="flex items-center gap-2">
                <img 
                  src="/logo-pismozapravdu.png" 
                  alt="Pismo za Pravdu Logo" 
                  class="h-8 w-auto"
                />
                <h1 class="text-xl font-bold">Pismo za Pravdu</h1>
              </router-link>
            </div>
            <div class="ml-6 flex items-center space-x-4">
              <router-link
                to="/admin/content"
                class="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-900 hover:text-indigo-600"
                :class="{ 'text-indigo-600': $route.path === '/admin/content' }"
              >
                Content
              </router-link>
              <router-link
                to="/admin/institutions"
                class="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-900 hover:text-indigo-600"
                :class="{ 'text-indigo-600': $route.path === '/admin/institutions' }"
              >
                Institutions
              </router-link>
              <router-link
                to="/admin/emails"
                class="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-900 hover:text-indigo-600"
                :class="{ 'text-indigo-600': $route.path === '/admin/emails' }"
              >
                Emails
              </router-link>
              <router-link
                to="/admin/replies"
                class="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-900 hover:text-indigo-600"
                :class="{ 'text-indigo-600': $route.path === '/admin/replies' }"
              >
                Replies
              </router-link>
              <router-link
                to="/admin/matters"
                class="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-900 hover:text-indigo-600"
                :class="{ 'text-indigo-600': $route.path === '/admin/matters' }"
              >
                Matters
              </router-link>
              <router-link
                to="/admin/outcomes"
                class="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-900 hover:text-indigo-600"
                :class="{ 'text-indigo-600': $route.path === '/admin/outcomes' }"
              >
                Outcomes
              </router-link>
              <router-link
                to="/admin/foi"
                class="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-900 hover:text-indigo-600"
                :class="{ 'text-indigo-600': $route.path === '/admin/foi' }"
              >
                FOI
              </router-link>
              <router-link
                to="/admin/follow-ups"
                class="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-900 hover:text-indigo-600"
                :class="{ 'text-indigo-600': $route.path === '/admin/follow-ups' }"
              >
                Follow-ups
              </router-link>
              <router-link
                to="/admin/citizen-campaigns"
                class="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-900 hover:text-indigo-600"
                :class="{ 'text-indigo-600': $route.path === '/admin/citizen-campaigns' }"
              >
                Campaigns
              </router-link>
            </div>
          </div>
          <div class="flex items-center">
            <button
              @click="handleLogout"
              class="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </nav>

    <!-- Main content -->
    <main>
      <div :class="mainContentClass">
        <router-view v-if="!authStore.loading" />
        <div v-else class="flex justify-center items-center h-screen">
          <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
        </div>
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
import { onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const router = useRouter()
const authStore = useAuthStore()

const mainContentClass = computed(() => {
  const excludedPaths = ['/', '/admin/login', '/admin/reset-password']
  return excludedPaths.includes(router.currentRoute.value.path) 
    ? '' 
    : 'mx-auto max-w-7xl py-6 sm:px-6 lg:px-8'
})

async function handleLogout() {
  await authStore.logout()
  router.push('/admin/login')
}

onMounted(() => {
  authStore.initialize()
})
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Exo+2:ital,wght@0,100..900;1,100..900&display=swap');
* {
  font-family: "Exo 2", serif;
}
</style>
